export interface TraceEntry {
  traceId: string;
  spanId: string;
}

let activeClickCtx: TraceEntry | null = null;
let activeSpan: any = null;
let endSpanTimer: ReturnType<typeof setTimeout> | null = null;

function generateHex(bytes: number): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  return Array.from(arr, b => b.toString(16).padStart(2, '0')).join('');
}

export function startClickSpan(label: string): TraceEntry {
  if (endSpanTimer) { clearTimeout(endSpanTimer); endSpanTimer = null; }
  if (activeSpan) { activeSpan.end(); activeSpan = null; }

  // Use Faro's OTel instance to create a real span — exports to Tempo so frontend
  // appears in the trace. Direct import of @opentelemetry/api hits a duplicate
  // un-registered copy; faro.api.getOTEL() returns the correct registered instance.
  const faroOTel = (window as any)?.faro?.api?.getOTEL?.();
  if (faroOTel) {
    const span = faroOTel.trace.getTracer('tc-click-tracker').startSpan(label);
    const ctx = span.spanContext();
    const isNoop = !ctx.traceId || ctx.traceId === '00000000000000000000000000000000';
    if (!isNoop) {
      activeSpan = span;
      activeClickCtx = { traceId: ctx.traceId, spanId: ctx.spanId };
      endSpanTimer = setTimeout(endClickSpan, 2000);
      return activeClickCtx;
    }
    span.end();
  }

  // Fallback: crypto IDs if Faro OTel not available yet
  activeClickCtx = { traceId: generateHex(16), spanId: generateHex(8) };
  endSpanTimer = setTimeout(endClickSpan, 2000);
  return activeClickCtx;
}

export function endClickSpan(): void {
  if (endSpanTimer) { clearTimeout(endSpanTimer); endSpanTimer = null; }
  if (activeSpan) { activeSpan.end(); activeSpan = null; }
  activeClickCtx = null;
}

export function getActiveClickContext(): TraceEntry | null {
  return activeClickCtx;
}

export function getActiveClickSpanContext(): TraceEntry | null {
  return activeClickCtx;
}
